/** Business status for schedule master tables (`status_id` → Active 1 / Inactive 0). */
export const SCHEDULE_MASTER_STATUS_OPTIONS = [
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];

export function isScheduleMasterStatusActive(row) {
  if (!row) return false;
  const status = row.status_id != null && row.status_id !== "" ? Number(row.status_id) : 1;
  return status === 1;
}
